import React from 'react';
import RagKGApp from '../libs/RagKGApp';

const DocumentManager: React.FC = () => {
  return (
    <div style={{ width: '100%', height: '98%' }}>
      <RagKGApp hashPath="documents" />
    </div>
  );
};

export default DocumentManager;

